import { FontSizes } from '@uifabric/styling';
import {
    CommonFloatingPickerItemStyleProps,
    CommonFloatingPickerItemStyles,
} from './CommonFloatingPickerItem.types';

export const getStyles = (
    props: CommonFloatingPickerItemStyleProps
): CommonFloatingPickerItemStyles => {
    const { theme, isHighlighted } = props;
    const { palette } = theme;

    return {
        container: [
            {
                height: '48px',
                width: '300px',
                maxWidth: '100%',
                overflow: 'hidden',
                position: 'relative',
                display: 'flex',
            },
            isHighlighted && {
                backgroundColor: palette.themeLighter,
            },
            [
                {
                    selectors: {
                        ':hover': {
                            backgroundColor: palette.neutralLighter,
                        },
                        ':hover .CommonFloatingPickerItem-maskPickerItemButton': {
                            opacity: 1,
                        },
                    },
                },
                isHighlighted && {
                    selectors: {
                        ':hover': {
                            backgroundColor: palette.themeLight,
                        },
                    },
                },
            ],
        ],
        maskPickerItemButton: [
            'CommonFloatingPickerItem-maskPickerItemButton',
            {
                height: '48px',
                width: 'calc(15% - 12px)',
                position: 'absolute',
                top: 0,
                right: 0,
                opacity: 0,
            },
            [
                {
                    selectors: {
                        ':hover': {
                            backgroundColor: palette.neutralLight,
                        },
                    },
                },
                isHighlighted && {
                    selectors: {
                        'hover:': {
                            backgroundColor: palette.themeTertiary,
                        },
                    },
                },
            ],
        ],
        personaContainer: [
            {
                marginLeft: '12px',
                marginTop: '8px',
                display: 'flex',
                tableLayout: 'fixed',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            },
        ],
        personaImage: [
            {
                position: 'relative',
                display: 'inline-block',
                verticalAlign: 'middle',
                width: '32px',
            },
        ],
        personaText: [
            {
                paddingLeft: '12px',
                display: 'inline-block',
                verticalAlign: 'middle',
                width: '80%',
            },
        ],
        cancelIcon: [
            {
                fontSize: FontSizes.small,
                color: palette.neutralPrimary,
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
            },
        ],
    };
};
